import * as angular from "angular";

import choicesSelect from "../choices-select/choices-select";
import timezoneSelect from "./timezone-select";

export default angular
	.module("vesl.components.timezone-select.index", [choicesSelect, timezoneSelect])
	.name;
